module.exports = __webpack_public_path__ + "imgs/SPLC.678bfe90d007169ab49ff5538373682f.png";